import { connect } from 'react-redux'
import { signIn, signOut, resetPassword } from '../actions'
import App from '../App.js'

const mapStateToProps = state => {
  return {
    user: state.user,
    admin: state.admin
  }
}

const mapDispatchToProps = dispatch => {
  return {
    signIn: (email, password) => dispatch(signIn(email, password)),
    signOut: () => dispatch(signOut()),
    resetPassword: email => dispatch(resetPassword(email))
  }
}

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(App)

export default AppContainer



// WEBPACK FOOTER //
// ./src/containers/appContainer.js